import axios from 'axios';
import { AuthHeader } from "../helper/auth.token"
import { Redirect } from 'react-router-dom';

// TODO: move constant SESSION_VALIDITY_CHECK_INITIATED to actionTypes folder
export const sessionValidityCheckInitiated = () => ({
    type: "SESSION_VALIDITY_CHECK_INITIATED",
})

export const checkSessionValidity = (callback) => (dispatch) => {
    dispatch(sessionValidityCheckInitiated());
    let url = "/check_session_validity";

    axios.get(url, {
            headers: { Authorization: AuthHeader(), 'Cache-Control': 'no-cache' }
        }).then(response => {
            if (response.status === 200) {
                callback(response.data.valid);
            } else {
                // TODO: handle
            }
        })
        .catch(err => {
            // TODO: handle
        })
}
